import { styled } from '@mui/material';
import { ReactComponent as IconTrash } from '../../../assets/images/trash.svg';

export const StyledIconTrash = styled(IconTrash)(() => ({
  height: '46px',
  width: '46px',
}));
